#FIXME: This should only be initialized if there is a data-livesearch element on a page
LiveSearch =
  currentQuery:  ''
  requestActive: false
  form:          null
  inputField:    null
  inputVisible:  false
  searchButton:  null

  init: ->
    @form = $('[data-livesearch]')
    @inputField = $(@form).find("input[type=text]").first()
    @searchButton =  $(@form).find('button.submit-search').first()
    @setupInputField()
    @bindInputs()
    @bindSearchButton()

  setupInputField: ->
    if $(@inputField).val().length
      @showInputField()

  showInputField: ->
    $(@searchButton).toggleClass('active')
    @inputField.toggleClass('visible')
    @inputVisible = true

  bindInputs: ->
    $(@inputField).bind 'keyup', =>
      unless @requestActive
        @currentQuery = $(@inputField).val()
        @makeRequest(@serializeFormData())
      @userId = @form.data('user-id')
      @fastFingers()

  bindSearchButton: ->
    $(@searchButton).on 'click', (event) =>
      if @inputVisible == false
        event.preventDefault()
        @showInputField()


  serializeFormData: (query) ->
    $("#hidden_activity_form_fields").serialize() + '&q=' + (encodeURIComponent(@currentQuery))

  fastFingers: ->
    setTimeout ( =>
      newQuery = $(@inputField).val()
      if newQuery != @currentQuery
        # If the input value isn't the same as the last query we used,
        # make a new request
        @currentQuery = newQuery
        @makeRequest(@serializeFormData())
    ), 1900

  makeRequest: (data) ->
    $.ajax
      url: $(@form).attr('action')
      data: data
      type: 'GET'
      beforeSend: (jqXHR, settings) =>
        #console.log("firing beforeSend, and settings.url is : " + settings.url)
        @requestActive = true
      success: (result) =>
        $('#user-activities-results').html(result)
        @requestActive = false
$(document).on 'turbo:load', ->
  if $('[data-livesearch]').length
    LiveSearch.init()


global.LiveSearch = LiveSearch

export default LiveSearch